<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN" }} UTILISATEUR</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false, initVal(), error_data =  []" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <vs-input autocomplete="off" class="mt-5 w-full" label="Nom"
                          :danger="error_data.name ? true : false"
                          :danger-text="error_data.name ? error_data.name[0] : ''"
                          v-model="name" placeholder="Nom" />

                <vs-input class="mt-5 w-full"
                          autocomplete="off"
                          label="Prénoms" v-model="first_name"
                          :danger="error_data.first_name ? true : false"
                          :danger-text="error_data.first_name ? error_data.first_name[0] : ''"
                          placeholder="Prénoms" />

                <vs-input class="mt-5 w-full"
                          :danger="error_data.email ? true : false"
                          :danger-text="error_data.email ? error_data.email[0] : ''"
                          label="Email" v-model="email"
                          placeholder="Email" />

                <vs-input class="mt-5 w-full"
                          autocomplete="off"
                          :danger="error_data.phone ? true : false"
                          :danger-text="error_data.phone ? error_data.phone[0] : ''"
                          label="Téléphone" v-model="phone"
                          placeholder="Téléphone" />

                <vs-select class="mt-5 w-full"
                           :danger="error_data.profile_id ? true : false"
                           :danger-text="error_data.profile_id ? error_data.profile_id[0] : ''"
                           v-model="profile_id" label="Type" autocomplete="">
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in profiles" />
                </vs-select>

                <template v-if="profile_id === 4">
                    <vs-select class="mt-5 w-full"
                               :danger="error_data.customer_id ? true : false"
                               :danger-text="error_data.customer_id ? error_data.customer_id[0] : ''"
                               v-model="customer_id" label="Client" autocomplete="">
                        <vs-select-item :key="item.id" :value="item.id" :text="item.social_reason" v-for="item in customers" />
                    </vs-select>

<!--                    <div class="mt-5">-->
<!--                        <vs-checkbox v-model="dataIsMaster">Gérer les utilisateurs du client</vs-checkbox>-->
<!--                    </div>-->
                </template>

                <template v-if="profile_id === 3">
                    <vs-select class="mt-5 w-full"
                               :danger="error_data.segment ? true : false"
                               :danger-text="error_data.segment ? error_data.segment[0] : ''"
                               v-model="segment" label="Segments" autocomplete="" multiple>
                        <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in segments" />
                    </vs-select>
                </template>

                <div class="mt-5">
                    <vs-checkbox v-model="dataStatus">Activer l'utilisateur</vs-checkbox>
                </div>
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="editEl === true ? updateInfo() : saveOrUpdate()" class="mr-6">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false, initVal(), error_data =  []">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {},
            },
            editEl: {
              type: Boolean
            },
            profiles:{
                type: Array,
                default: () => []
            },
            customerFunction:{
                type: Function
            },
            segmentFunction:{
                type: Function
            },
            userFunction:{
              type: Function
            },
            customers: {
                type: Array,
                default: () => []
            },
            segments: {
              type: Array,
              default: () => []
            }
        },
        data() {
            return {
                dataId: '',
                first_name: '',
                name: '',
                email: '',
                phone: '',
                profile_id: '',
                customer_id: '',
                dataIsMaster: false,
                segment: [],
                dataStatus: true,
                dataSendCredentials: true,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                error_data: []
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
        },
        methods: {
            initValues() {
                if(this.data.id) return;
                this.dataId = '';
            },
            initVal(){
                this.dataId = ''
                this.first_name = '';
                this.name = '';
                this.email = '';
                this.phone = '';
                this.profile_id = '';
                this.customer_id = '';
                this.segment = '';
            },
            saveOrUpdate(){
              this.$vs.loading()
              this.$http.post('/users/create', {
                first_name: this.first_name,
                name: this.name,
                email: this.email,
                phone: this.phone,
                profile_id: this.profile_id,
                customer_id: this.customer_id,
                segment: this.segment,
                status: this.dataStatus
              }).then(() => {
                this.error_data = []
                this.$vs.loading.close()
                this.initVal()
                this.$emit('closeSidebar')
                window.GETCCMT.success('Opération effectuée', {});
                this.userFunction(1)
              }).catch((error) => {
                this.$vs.loading.close()
                this.error_data = error.response.data.errors
              })
            },
            updateInfo(){
              this.$vs.loading()
              this.$http.post('/users/update', {
                id: this.dataId,
                first_name: this.first_name,
                name: this.name,
                email: this.email,
                phone: this.phone,
                profile_id: this.profile_id,
                customer_id: this.customer_id,
                segment: this.segment,
                status: this.dataStatus
              }).then(() => {
                this.error_data = []
                this.$vs.loading.close()
                this.initVal()
                window.GETCCMT.success('Opération effectuée', {});
                this.$emit('closeSidebar')
                this.userFunction(1)
              }).catch((error) => {
                this.$vs.loading.close()
                this.error_data = error.response.data.errors
              })
            }
        },
        watch: {
            profile_id(value){
                if(value){
                  if (value === 4) this.customerFunction()
                  if (value === 3) {
                    this.segmentFunction()
                  }
                }
            },
            isSidebarActive(val) {
                if(!val) return;
                if(Object.entries(this.data).length === 0) {
                    this.initValues()
                } else {
                    let { id, customer_id, email, first_name, name, phone, profile_id, segment_list, status } = JSON.parse(JSON.stringify(this.data));
                    this.dataId = id
                    this.first_name = first_name
                    this.name = name
                    this.email = email
                    this.phone = phone
                    this.profile_id = profile_id
                    this.customer_id = customer_id
                    this.segment = segment_list
                    this.status = status
                    //this.initValues();

                }
            },
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
    .vs-input-number {
        justify-content: space-around;
    }
</style>
